import { useState } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useSnackbar } from "../../core/contexts/SnackbarContext";
import { IMaquininha } from "../interface/IMaquininha";

export const useMaquininhas = () => {
    const [loading, setLoading] = useState(false);
    const snackbar = useSnackbar();
    const apiPedidos = ApiFactory.getApi("MS_PEDIDOS");

    const criar = async (maquininha: IMaquininha) => {
        setLoading(true);
        try {
            const { data } = await apiPedidos.post('/maquininhas', maquininha);
            snackbar("Maquininha cadastrada com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao cadastrar a maquininha", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const atualizar = async (uuid: string, maquininha: IMaquininha) => {
        setLoading(true);
        try {
            const { data } = await apiPedidos.put(`/maquininhas/${uuid}`, maquininha);
            snackbar("Maquininha atualizada com sucesso", { severity: "success" });
            return data;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao atualizar a maquininha", { severity: "error" });
            return null;
        } finally {
            setLoading(false);
        }
    }

    const deletar = async (uuid: string) => {
        setLoading(true);
        try {
            await apiPedidos.delete(`/maquininhas/${uuid}`);
            snackbar("Maquininha excluída com sucesso", { severity: "success" });
            return true;
        } catch (error: any) {
            snackbar(error?.response?.data?.message || "Ocorreu um erro ao excluir a maquininha", { severity: "error" });
            return false;
        } finally {
            setLoading(false);
        }
    }

    return { criar, atualizar, deletar, loading }
}
